import React from 'react';
import { Box, FormControl, Select, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useSelector } from 'react-redux';

function ViewModeSelector({ viewMode, onViewModeChange }) {
  const theme = useSelector((state) => state.themedata.theme);

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        zIndex: 2,
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'transparent',
        padding: 1,
      }}
    >
      <FormControl variant="standard" sx={{ marginTop: '0px', minWidth: 50 }}>
        <Select
          value={viewMode}
          IconComponent={KeyboardArrowDownIcon}
          sx={{
            '&:before': {
              borderBottom: `1px solid ${theme === 'light' ? '#3C3C3C' : '#FFFFFF'}`,
            },
            '&:hover:not(.Mui-disabled):before': {
              borderBottom: '2px solid #008CD7',
            },
            '&:after': {
              borderBottom: '2px solid #008CD7',
            },
            margin: 0,
            padding: 0,
            width: '175px',
            fontSize: '18px',
            fontFamily: 'Roboto',
            fontWeight: '700 !important',
            color: 'var(--PrimaryText)',
            '& .MuiInputBase-input': { paddingLeft: 0 },
            '& .MuiInputBase-input:focus': {
              color: 'var(--HighlightedText_Stroke)',
              borderBottom: '2px solid var(--HighlightedText_Stroke)',
              backgroundColor: 'transparent',
              fontWeight: '700 !important',
              '& .MuiSvgIcon-root': {
                color: 'var(--HighlightedText_Stroke) !important',
              },
            },
            '& .MuiSvgIcon-root': { color: 'var(--PrimaryText)' },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                width: '100px',
                bgcolor: theme === 'dark' ? '#3C3C3C' : '#C1C1C1',
                borderBottom: '2px solid #008CD7',
                borderRadius: 0,
                boxShadow: 'none',
                maxHeight: '250px',
                overflow: 'auto',
                color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C',
              },
            },
          }}
          label=""
          onChange={(e) => onViewModeChange(e.target.value)}
        >
          <MenuItem sx={{ paddingLeft: 1 }} value="color">Solid</MenuItem>
          <MenuItem sx={{ paddingLeft: 1 }} value="translucent">Translucent</MenuItem>
          <MenuItem sx={{ paddingLeft: 1 }} value="wireframe">Wireframe</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}

export default React.memo(ViewModeSelector);
